import { jsx } from "react/jsx-runtime";
import {
  isRichTextV1Data
} from "../../../../controls";
import { useIsPreview } from "../../../react";
import { forwardNextDynamicRef } from "../../../../next/dynamic";
import dynamic from "next/dynamic";
const EditableText = forwardNextDynamicRef(
  (patch) => dynamic(() => patch(import("./EditableTextV2")))
);
const ReadOnlyText = forwardNextDynamicRef(
  (patch) => dynamic(() => patch(import("./ReadOnlyTextV2")))
);
const ReadOnlyTextV1 = forwardNextDynamicRef(
  (patch) => dynamic(() => patch(import("../rich-text/ReadOnlyText")))
);
function useRichTextV2(data, definition, control) {
  const isPreview = useIsPreview();
  if (isRichTextV1Data(data)) {
    return /* @__PURE__ */ jsx(ReadOnlyTextV1, { text: data });
  }
  return isPreview ? /* @__PURE__ */ jsx(EditableText, { text: data, definition, control }) : /* @__PURE__ */ jsx(ReadOnlyText, { text: data, definition });
}
export {
  useRichTextV2
};
//# sourceMappingURL=rich-text-v2.js.map